export const MARKET_TYPES = [
  { value: 'local-shops', label: 'Local Shops' },
  { value: 'sunday-market', label: 'Sunday Market' },
  { value: 'supermarket', label: 'Supermarket' },
  { value: 'ecommerce', label: 'Ecommerce' },
  { value: 'distribution-center', label: 'Distribution Center' }
];

export const LOCATION_OPTIONS = {
  'local-shops': [
    'benchmark location 1 Suk Bole',
    'benchmark location 2 Suk Gulele',
    'benchmark location 3 Suk Yeka',
    'benchmark location 4 Suk Arada',
    'benchmark location 5 Suk Lideta',
    'benchmark location 6 Suk Gulele',
    'benchmark location 7 Suk Ayat',
    'benchmark location 8 Merkato',
    'benchmark location 9 Sholla'
  ],
  'sunday-market': [
    'benchmark location 1 Sunday market Piaza',
    'benchmark location 2 Sunday market Bole',
    'benchmark location 2 Sunday market Gerji',
    'benchmark location 4 Sunday market Kolfe',
    'benchmark location 5 Sunday market Lideta',
    'benchmark location 6 Sunday market Gulele',
    'benchmark location 7 Sunday market Ayat',
    'Benchmark Location 8  Sunday Market Abnet',
    'Benchmark Location 9  Sunday Market 22'
  ],
  'supermarket': [
    'benchmark location 1 supermarket Queens',
    'benchmark location 2 supermarket lomyad',
    'benchmark location 3 supermarket FreshCorner',
    'benchmark location 4 supermarket Shoa',
    'benchmark location 5 supermarket Friendship',
    'benchmark location 6 supermarket Emawa'
  ],
  'ecommerce': [
    'ZemenGebeya -YegnaGebeya',
    'ZemenGebeya -AradaMart',
    'ZemenGebeya -Ecomart',
    'ZemenGebeya - Eba Supplier',
    'AradaMart'
  ],
  'distribution-center': [
    'Distribution center 1 Gerji',
    'Distribution center 2 Garment',
    'Distribution center 3 02',
    'Distribution center 4 6Killo',
    'Distribution center 5 Ayat Yafo'
  ],
  'merkato': [
    'Merkato - Adarash',
    'Merkato - Autobis Tera',
    'Merkato - Ehil Berenda',
    'Merkato - Gojam Berenda',
    'Merkato - Addis Ketema',
    'Merkato - Shera Tera',
    'Merkato - Tana',
    'Merkato - Asko',
    'Merkato - Sebategna',
    'Merkato - Piazza',
    'Merkato - Kolfe'
  ]
};

export const FMCG_PRODUCT_CATEGORIES = [
  'Baby Items',
  'Baking Goods',
  'Beverages',
  'Biscuits & Snacks',
  'Bread & Bakery',
  'Breakfast Items',
  'Canned Goods',
  'Cleaning Products',
  'Condiments & Sauces',
  'Confectionery',
  'Dairy Products',
  'Frozen Foods',
  'Grains & Cereals',
  'Health & Beauty',
  'Household Items',
  'Instant Foods',
  'Oils & Fats',
  'Paper Products',
  'Pasta & Noodles',
  'Personal Care',
  'Pet Food',
  'Spices & Seasonings',
  'Sugar & Sweeteners',
  'Tea & Coffee',
  'Tobacco Products',
  'Other'
];

export const AVAILABLE_PRODUCTS = [
  'Apple',
  'Avocado',
  'Avocado B',
  'Banana',
  'Beetroot',
  'Broccoli',
  'Carrot',
  'Carrot B',
  'Chilly Green',
  'Chilly Green (Elfora)',
  'Chilly Green (Starter)',
  'Courgette',
  'Cucumber',
  'Eggplant',
  'Garlic',
  'Garlic B',
  'Ginger',
  'Grean Beans',
  'Lemon',
  'Mango',
  'Mango Apple',
  'Orange Valencia',
  'Orange Yerer',
  'Papaya',
  'Papaya B',
  'Pineapple',
  'Pineapple B',
  'Potatoes',
  'Potatoes Chips',
  'Red Onion Elfora',
  'Red Onion Grade A',
  'Red Onion Grade B',
  'Red Onion Grade C',
  'Strawberry',
  'Sweet Potatoes',
  'Tomatoes Grade A',
  'Tomatoes Grade B',
  'Valencia Orange',
  'White Cabbage',
  'White Cabbage B',
  'Zucchini'
];
